import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_close_bold = _resolveComponent("close-bold")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_image, {
      style: {"width":"100%"},
      src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/update-password-title-bg.png`,
      fit: "fill"
    }, null, 8, ["src"]),
    (_ctx.showCloseBtn)
      ? (_openBlock(), _createBlock(_component_close_bold, {
          key: 0,
          class: "close-icon",
          onClick: _ctx.onClose
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      class: "upd-password-form",
      size: "large",
      style: {"padding":"25px 60px 32px 60px"},
      "label-position": "top",
      "hide-required-asterisk": "",
      model: _ctx.changePasswordData,
      rules: _ctx.rules,
      onKeydown: _withKeys(_ctx.onChangePassword, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "旧密码：",
          prop: "oldPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.changePasswordData.oldPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.changePasswordData.oldPassword) = $event)),
              placeholder: "请输入旧密码",
              type: "password",
              size: "large"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "新密码：",
          prop: "newPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.changePasswordData.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.changePasswordData.newPassword) = $event)),
              placeholder: "请输入新密码",
              "show-password": "",
              size: "large"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "确认密码：",
          prop: "newPasswordRe"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.changePasswordData.newPasswordRe,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.changePasswordData.newPasswordRe) = $event)),
              placeholder: "请再次输入新密码",
              "show-password": "",
              size: "large"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100%"},
          size: "large",
          onClick: _ctx.onChangePassword
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["model", "rules", "onKeydown"])
  ]))
}